
//directive controller function
var MapControllerFunction = function ($scope, $element, ngMap) {

    var googleMapApiKey = window.appSettings.googleMapApiKey;
    this.googleMapsUrl = 'https://maps.google.com/maps/api/js?key=' + googleMapApiKey;

    this.onInit = function (map) {

        function offsetCenter(latlng, offsetx, offsety) {

            // latlng is the apparent centre-point
            // offsetx is the distance you want that point to move to the right, in pixels
            // offsety is the distance you want that point to move upwards, in pixels
            // offset can be negative
            // offsetx and offsety are both optional

            var scale = Math.pow(2, map.getZoom());

            var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
            var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);

            var worldCoordinateNewCenter = new google.maps.Point(
                worldCoordinateCenter.x - pixelOffset.x,
                worldCoordinateCenter.y + pixelOffset.y
            );

            var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

            map.setCenter(newCenter);

        }

        ngMap.getGeoLocation($scope.info.addressCoords).then(function (latlng) {
            var o = $element[0].clientWidth / -4;
            offsetCenter(latlng, o, 0);
        });
    };
};
//directive controller function injections
MapControllerFunction.$inject = ['$scope', '$element', 'NgMap'];
//directive link function
var MapLinkFunction = function ($scope, $iElement, $iAttrs) {

    var iconColor = '#0768B1';
    switch (window.settings_theme) {
        case 'generic':
            iconColor = '#cd0c3c';
            break;
        case 'audi':
            iconColor = '#cd0c3c';
            break;
        case 'volkswagen':
            iconColor = '#1fb0e6';
            break;
        case 'fca':
            iconColor = '#0768B1';
            break;
        case 'toyota':
        case 'toyotasmartpath':
            iconColor = '#CD0000';
            break;
        case 'lexus':
        case 'lexusmonogram':
            iconColor = '#000000';
            break;
        case 'nissan':
            iconColor = '#d50044';
            break;
        case 'mitsubishi':
            iconColor = '#f5021c';
            break;
        case 'infiniti':
            iconColor = '#000000';
            break;
        case 'porsche':
            iconColor = '#d5001c';
            break;
        default:
            break;
    }

    $scope.icon = {
        path: 'm0.32129,-29.90039c-6.075,0 -11,4.924 -11,11c0,6.075 11,18.678 11,18.678s11,-12.604 11,-18.678c0,-6.076 -4.926,-11 -11,-11m0,16.87c-2.986,0 -5.408,-2.422 -5.408,-5.41c0,-2.985 2.42,-5.406 5.408,-5.406s5.408,2.42 5.408,5.407c0,2.988 -2.422,5.41 -5.408,5.41',
        fillColor: iconColor,
        fillOpacity: 1,
        scale: 1.5,
        strokeColor: iconColor,
        strokeWeight: 0
    };

};
//directive link function injections
MapLinkFunction.$inject = ['$scope', '$element', '$attrs'];

module.exports = function () {
    return {
        replace: true,
        template: '<div class="map" map-lazy-load="{{mapController.googleMapsUrl}}">' +
            '	<ng-map disable-default-u-i="true" map-initialized="mapController.onInit(map)">' +
            '		<marker position="{{ info.addressCoords }}" dragglele="false" icon="{{icon}}"></marker>' +
            '	</ng-map>' +
            '</div>',
        restrict: 'E',
        link: MapLinkFunction,
        controllerAs: 'mapController',
        controller: MapControllerFunction,
        scope: {
            info: '='
        }
    }
};
